// extracted by mini-css-extract-plugin
export default {"container":"ServiceStatus_container__19o9Q","slotText":"ServiceStatus_slotText__NFsbT","noSlotText":"ServiceStatus_noSlotText__sOTdh"};